import { render, staticRenderFns } from "./LogoBadge.vue?vue&type=template&id=6a12c3f4&scoped=true"
import script from "./LogoBadge.vue?vue&type=script&lang=js"
export * from "./LogoBadge.vue?vue&type=script&lang=js"
import style0 from "./LogoBadge.vue?vue&type=style&index=0&id=6a12c3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12c3f4",
  null
  
)

export default component.exports